<template>
  <div>
    <div class="marTML pf23-subTit" id="activity_top">
      <div class="widM fntH4 bold padTS padBS" style="color:#fff;">액티비티 예약</div>
    </div>

    <div class="activeityScrollWrap marTML">
      <!-- <div class="activeityScroll"> 사진이 너무 커져서 제거 -->
      <div>
        <img src="@/views/surveys/sapporo/images/activity/activity_schedule.jpg" alt="스케쥴표">
      </div>
      <p class="pf23-tit fntH5 bold moTxtL txtC" style="color:#2c2c2c; letter-spacing: normal;">액티비티는 1일 1액티비티에 한해서 신청이 가능합니다</p>
    </div>

    <div class="widM txtC marTML">
      <a @click="openActivityPopup" class="disIb fntH5 bold pf23-activeBtn" >
        액티비티 정보 안내 &nbsp;
        <img src="@/views/surveys/sapporo/images/NCAcmi_arrow.png" alt="" class="verM" style="max-width:10px; width:2%;">
      </a>
      <p class="fntE txtL marTSM" style="color:#d91734;">* 액티비티 별 잔여인원은 제출 시간에 따라 차이가 있을 수 있습니다.</p>
    </div>

    <!-- <hr style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;">-->

    <template v-for="(activity, sq_code, i) in activities">
      <SurveyActivityParticipant
        :key="`activity_${sq_code}`"
        :activity="activity"
        :is-first="i === 0"
      />
      <!-- <hr
        v-if="i < activityCount - 1"
        :key="`hr_${activity.sq_code}`"
        style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;"> -->
    </template>
  </div>
</template>

<script>
import { CommonMethodMixin } from '../mixins'
import { SURVEY_SAPPORO, ACTIVITY_QUESTIONS, TOGGLE_ACTIVITY_POPUP } from '@/store/actions/survey'
import { mapGetters } from 'vuex'
import SurveyActivityParticipant from './SurveyActivityParticipant.vue'

export default {
  name: 'SurveyActivityList',
  mixins: [CommonMethodMixin],
  components: {
    SurveyActivityParticipant,
  },
  computed: {
    ...mapGetters(SURVEY_SAPPORO, {
      activities: ACTIVITY_QUESTIONS,
    }),
    activityCount() {
      return Object.keys(this.activities).length;
    }
  },
  methods: {
    openActivityPopup() {
      this.$store.commit(`${SURVEY_SAPPORO}/${TOGGLE_ACTIVITY_POPUP}`, true);
    }
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/surveys/sapporo/components/SurveyActivityList.vue